<template>
<v-container fluid class="grey lighten-4">
    <v-layout justify-center row wrap >
        <v-flex flex xs12 sm12 md6 lg6>
            <v-tabs background-color="red" color="white" grow>
                <v-tab class="red darken-4 white--text">
                    VIDEO DISPONIBILI
                </v-tab>
            </v-tabs>
            <v-data-table :items="events" hide-actions hide-headers class="elevation-1 mb-5" style="width: 100%">
                <template slot="items" slot-scope="props">
                    <tr style="height: 50px" class="mb-0 pa-2" @click="gotoEvento(props.item)">
                        <td class="pa-2 no-wrap" style="text-align: center">
                            <strong>{{
                                            props.item.data
                                        }}</strong><br>{{
                                            props.item.localita
                                        }}
                        </td>
                        <td class="pa-2">
                            {{ props.item.titolo }}
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-flex>
        <v-flex flex xs12 sm12 md6 lg6>
            <v-tabs background-color="grey" color="white" grow>
                <v-tab class="grey black--text">
                    PROSSIMI VIDEO
                </v-tab>
            </v-tabs>

            <v-data-table :items="nextEvents" hide-actions hide-headers class="elevation-1 mb-5" style="width: 100%">
                <template slot="items" slot-scope="props">
                    <tr style="height: 50px" class="mb-0 pa-2" @click="gotoEvento(props.item)" >
                        <td class="pa-2 no-wrap" style="text-align: center">
                            <strong>{{
                                            props.item.data
                                        }}</strong><br>{{
                                            props.item.localita
                                        }}
                        </td>
                        <td class="pa-2">
                            {{ props.item.titolo }}
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-flex>
        <v-flex flex xs12 sm12 md12 lg12 style="border: 1px solid black" class="mt-3 pa-2 grey lighten-2 black--text"> <strong> Cos'e' CAM-ON ? </strong></v-flex>
        <v-flex flex xs12 sm12 md12 lg12 style="border: 1px solid black" class="mt-0 pa-2 white lighten-2 black--text">
            <p align="justify"> CAM-ON è un servizio di generazione automatica di video personalizzati relativi ad eventi sportivi <br> I video sono in alta risoluzione con applicazione di grafica televisiva professionale</p>
        </v-flex>
        <v-flex flex xs12 sm12 md12 lg12 style="border: 1px solid black" class="mt-3 pa-2 grey lighten-2 black--text"> <strong> Come funziona ? </strong> </v-flex>
        <v-flex flex xs12 sm12 md12 lg12 style="border: 1px solid black" class="mt-0 pa-2 white lighten-2 black--text">
            <p align="justify"> CAM-ON è un sistema di montaggio automatico di video basato su un algoritmo di analisi dei rilevamenti.<br>Tutti i dati sono presentati in grafica televisiva per rendere il video molto accattivante. <br><br><strong>Nota: Nelle gare a batteria il video "segue" i rilevamenti del vincitore.</strong><br><br> Potrebbe capitare che in gare molto lunghe non tutti gli atleti abbiamo la stessa presenza in video.<br>Per questo motivo e' possibile acquistare un video personalizzato che inquadra uno specifico atleta. </p>
        </v-flex>
        <v-flex flex xs12 sm12 md12 lg12 style="border: 1px solid black" class="mt-3 pa-2 grey lighten-2 black--text"> <strong> Quanto costa ? </strong> </v-flex>
        <v-flex flex xs12 sm12 md12 lg12 style="border: 1px solid black" class="mt-0 pa-2 white lighten-2 black--text">
            <p align="justify"> Il costo del servizio dipende da evento ad evento. Spesso i video sono acquistati interamente dall'organizzatore oppure dai singoli atleti. In altri casi i video sono commissionati da sponsor che cercano visibilità dei propri brand</p>
        </v-flex>
        <v-flex flex xs12 sm12 md12 lg12 style="border: 1px solid black" class="mt-3 pa-2 red darken-4 white--text"> VUOI CAM-ON AL TUO EVENTO ? CONTATTACI <br /> Email - info@camon-sport.it </v-flex>
    </v-layout>
</v-container>
</template>

<script>
export default {
    components: {},
    name: 'HomeDetails',
    data: () => ({
        version: undefined,
        events: [],
        nextEvents: []
    }),
    mounted() {
        this.version = global.helper.ls.get('icronsport-videoversion');
        this.checkFEVersion();
        this.getEvents();
        this.getNextEvents();
    },
    methods: {
        gotoEvento: function (evento) {
            this.$router.push('/generic/' + evento.divisione);
        },

        getEvents() {
            this.getVideoData('eventi').then((response) => {
                this.events = this.csvJSON(response);
            });
        },

         getNextEvents() {
            this.getVideoData('eventifuturi').then((response) => {
                this.nextEvents = this.csvJSON(response);
            });
        },


        checkFEVersion() {
            let self = this;
            this.checkVersion({}).then((res) => {
                //console.log(res);
                console.log(
                    'CHECK VERSION:' + self.version + ' - ' + res.version
                );
                if (self.version == undefined) {
                    global.helper.ls.set('icronsport-videoversion', res.version);
                    this.version = res.version;
                } else {
                    if (res.version != self.version) {
                        console.log(
                            'Trovato aggiornamento piattaforma. ' +
                            self.version +
                            ' --> ' +
                            res.version
                        );
                        global.helper.ls.set('icronsport-videoversion', res.version);
                        location.reload(true);
                    }
                }
            });
        },
    },
};
</script>

<style scoped></style>
